import React from 'react';
import "./pie-chart-footer.css";
import FooterLink from "../footer-link/footer-link-component";

const PieChartFooter = ({link}) => {

  return (
    <div className="chart__footer">
      <FooterLink
        link={link}
        name="Full report"
      />
    </div>
  )
};


export default PieChartFooter;


// WEBPACK FOOTER //
// ./src/components/pie-chart-footer/pie-chart-footer-component.js